import { Tooltip as ReactTooltip } from 'react-tooltip';
import { HiOutlineInformationCircle } from 'react-icons/hi';

/**
 * Title block for the new product modal — rendered below (mobile) or
 * beside (desktop split) the hero image.
 */
const ProductTitleBlock = ({ product, coupon, kcalLabel }) => {
  const platformTags = product?.tags?.platformTags || [];
  const customTags = product?.tags?.customProductTags || [];

  const hasWebPlatform = platformTags.some((tag) => tag.isWeb);
  const hasKioskPlatform = platformTags.some((tag) => tag.isKiosk);
  const hasMobilePlatform = platformTags.some((tag) => tag.isMobile);
  const availablePlatformsCount = [
    hasWebPlatform,
    hasKioskPlatform,
    hasMobilePlatform,
  ].filter(Boolean).length;
  const showWebsiteOnlyTag =
    platformTags.length > 0 && availablePlatformsCount === 1 && hasWebPlatform;

  const buyCount = coupon?.BuyItemCount || coupon?.buyItemCount || 1;
  const getCount = coupon?.GetItemCount || coupon?.getItemCount || 1;

  return (
    <div>
      {coupon?.type === 2 && (
        <div
          className="inline-flex items-center gap-2 mb-3"
          style={{
            padding: '5px 12px',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            background: '#D97706',
            color: '#FFFFFF',
            borderRadius: '100px',
          }}
        >
          Buy {buyCount} · Get {getCount} free
        </div>
      )}

      <div className="flex flex-wrap items-end gap-x-3 gap-y-1">
        <h1
          className="leading-[1.15]"
          style={{
            fontSize: '26px',
            fontWeight: 800,
            letterSpacing: '-0.028em',
            color: 'var(--ui-ink)',
            margin: 0,
          }}
        >
          {product.name}
        </h1>
        {kcalLabel && (
          <span
            className="inline-flex items-center gap-1"
            style={{ paddingBottom: '3px' }}
          >
            <span
              style={{
                fontSize: '15px',
                fontWeight: 600,
                color: 'var(--ui-ink-3)',
                whiteSpace: 'nowrap',
              }}
            >
              {kcalLabel}
            </span>
            <HiOutlineInformationCircle
              size={16}
              color="var(--ui-ink-3)"
              style={{ cursor: 'help' }}
              data-tooltip-id="product-kcal-info"
              data-tooltip-content="Calorie information is entered by the restaurant and may be an estimate. Actual calories may vary."
            />
            <ReactTooltip
              id="product-kcal-info"
              place="bottom"
              style={{ maxWidth: '280px', zIndex: 60 }}
            />
          </span>
        )}
      </div>

      {product.description && (
        <p
          className="mt-2"
          style={{
            fontSize: '14px',
            lineHeight: 1.5,
            color: 'var(--ui-ink-2)',
            margin: '8px 0 0',
          }}
        >
          {product.description}
        </p>
      )}

      {(showWebsiteOnlyTag || customTags.length > 0) && (
        <div className="flex flex-wrap gap-[6px] mt-4">
          {showWebsiteOnlyTag && (
            <span
              style={{
                padding: '3px 9px',
                borderRadius: '100px',
                fontSize: '10.5px',
                fontWeight: 700,
                letterSpacing: '0.02em',
                background: 'rgba(21, 128, 61, 0.1)',
                color: 'var(--ui-green)',
              }}
            >
              Web only
            </span>
          )}
          {customTags.map((tag) => (
            <span
              key={tag.id}
              style={{
                padding: '3px 9px',
                borderRadius: '100px',
                fontSize: '10.5px',
                fontWeight: 700,
                letterSpacing: '0.01em',
                backgroundColor: tag.color,
                color: tag.textColor,
              }}
            >
              {tag.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductTitleBlock;
